import PopupActions from '../../../../actions/PopupActions';
import UserStore from '../../../../stores/UserStore';
import PosCartStore from '../../../../stores/PosCartStore';
import AvailableFeesDonations from './AvailableFeesDonations.react'
import AddFeeDonation from './AddFeeDonation.react'

class PosFeeDonation extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            locationInfo : UserStore.getState().selectedLocation,
            selectedFeeDonation : false
        };
    }

    render() {
        var selectedFeeDonation     = this.state.selectedFeeDonation;
        var guest                   = this.props.guest
        var cart                    = PosCartStore.getState().cart;

        return (
            <div className='popup__content discount'>

                <div className='popup-header'>
                    FEES &amp; DONATIONS

                    <div
                        className='popup-close'
                        onClick={() => { PopupActions.close(); }}>

                        <i className='fa fa-times' aria-hidden='true' />
                    </div>
                </div>


                <AvailableFeesDonations
                    selectedFeeDonation={selectedFeeDonation}
                    selectFeeDonation={(selectedFeeDonation) => {this.setState({selectedFeeDonation})}} />

                <AddFeeDonation
                    cart={cart}
                    guest={guest}
                    selectedFeeDonation={selectedFeeDonation} />
            </div>
        );
    }
}

export default PosFeeDonation;


// WEBPACK FOOTER //
// ./ui_src/app/components/pos/sidebar/feesDonations/PosFeeDonation.react.jsx